@if (user) {
  <div class="card clickable-card cursor-poiner car-popup-card" (click)="goToDetails(user.id)">
    <div class="card popup-card">
      <div class="row g-0 shiny-bg">
        <div class="col-6">
          <img class="map-item-height cover w-100" [src]="user.officePhotoUrl" alt="Image Title" />
        </div>
        <div class="col-6 p-2">
          <div class="d-flex justify-content-between">
            <h6 class="card-title">
              {{ user.name }}
            </h6>
            <i class="bi bi-x" (click)="onClose($event)"></i>
          </div>
          <div class="row">
            <div class="col-12">
              <p class="card-text">
                <a (click)="openWhatsApp($event, user.phoneNumber)"
                  ><i class="bi bi-whatsapp text-success"></i> {{ user.phoneNumber }}</a
                >
              </p>
            </div>
            <div class="col-12">
              <p class="card-text">
                @if (user.carCount > 0) {
                  <i class="bi bi-car-front-fill px-1"></i>{{ user.carCount }}
                }
                @if (user.realEstateCount > 0) {
                  <i class="bi bi-buildings-fill px-1"></i>{{ user.realEstateCount }}
                }
              </p>
            </div>
            <div class="col-12">
              <p class="card-text">
                @if (user.city) {
                  <i class="bi bi-geo-alt-fill"></i>{{ user.city | translate }}
                }
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}
